var T = Object.defineProperty, r = Object.defineProperties;
var v = Object.getOwnPropertyDescriptors;
var x = Object.getOwnPropertySymbols;
var z = Object.prototype.hasOwnProperty, k = Object.prototype.propertyIsEnumerable;
var F = (l, i, e) => i in l ? T(l, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[i] = e, d = (l, i) => {
  for (var e in i || (i = {}))
    z.call(i, e) && F(l, e, i[e]);
  if (x)
    for (var e of x(i))
      k.call(i, e) && F(l, e, i[e]);
  return l;
}, f = (l, i) => r(l, v(i));
import { jsxs as C, jsx as b } from "react/jsx-runtime";
import c from "../../../../node_modules/prop-types/index.es.js";
import * as M from "./style.es.js";
import { Footer as N, CustomButton as a } from "./style.es.js";
import { buttonPropTypes as m } from "../../../Inputs/Button/common.es.js";
const j = ({
  components: l,
  onRequestClose: i,
  primaryButtonProps: e,
  secondaryButtonProps: h,
  footerProps: S
}) => /* @__PURE__ */ C(N, f(d({}, S), { children: [
  (l == null ? void 0 : l.SecondaryContent) && /* @__PURE__ */ b(l.SecondaryContent, {}),
  (h == null ? void 0 : h.children) && /* @__PURE__ */ b(a, f(d({ variant: "text", color: "neutral", size: "sm", onClick: () => i == null ? void 0 : i(!1) }, h || {}), { children: h.children })),
  (e == null ? void 0 : e.children) && /* @__PURE__ */ b(a, f(d({ variant: "contained", color: "primary", size: "sm", type: "submit" }, e || {}), { children: e == null ? void 0 : e.children }))
] }));
j.S = M;
j.displayName = "Modal.Footer";
j.propTypes = {
  components: c.object,
  onRequestClose: c.func.isRequired,
  primaryButtonProps: c.shape(m),
  secondaryButtonProps: c.shape(m),
  footerProps: c.object
};
export {
  j as Footer
};
//# sourceMappingURL=Footer.es.js.map
